import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { jbPalette } from '@el2/theme';
import { motion } from 'framer-motion';
import { EASING_BEZIER } from 'app/config';
import { Box, Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getMapBridge } from 'features/map';
import { screenToRoutesMap } from 'features/routes/appRoutes';
import { InternalNavigationScreens } from 'features/entities/entitiesTypes';

import { ReactComponent as ErrorIcon } from 'common/assets/error.svg';

export const MigrationErrorScreen = () => {
  const theme = useTheme();
  const isTabletWidth = useMediaQuery('(min-width:481px)');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleTryAgain = useCallback(() => getMapBridge().closePage(), []);

  const handleContactSupport = useCallback(
    () => navigate(screenToRoutesMap[InternalNavigationScreens.CONTACT_SCREEN]),
    [navigate]
  );

  return (
    <motion.div
      style={{
        flex: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',

        alignItems: 'center',
      }}
      initial={{ x: window.innerWidth }}
      animate={{ x: 0 }}
      exit={{ x: window.innerWidth }}
      transition={{ ease: EASING_BEZIER, duration: 0.2 }}
    >
      <Box
        sx={{
          maxWidth: '554px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          px: 3,
          py: 5,
          justifyContent: 'space-between',
          zIndex: 1,
          overflow: 'hidden',
          ...(isTabletWidth && {
            pt: 8,
            pb: 10,
          }),
        }}
      >
        <Stack gap={5}>
          <ErrorIcon {...(isTabletWidth && { width: 92, height: 92 })} />
          <Stack gap={2}>
            <Typography
              variant="h1"
              sx={{
                color: jbPalette.primary.royalBlue900,
                fontSize: (theme) => theme.typography.pxToRem(24),
                lineHeight: '28px',
              }}
            >
              {t('migration.step.error.title')}
            </Typography>
            <Typography
              component="div"
              sx={{
                fontWeight: 'fontWeightRegular',
                lineHeight: '22px',
              }}
            >
              {t('migration.step.error.description')}
            </Typography>
          </Stack>
        </Stack>
        <Stack gap={1}>
          <Button onClick={handleTryAgain} variant="contained" fullWidth>
            {t('migration.step.error.tryAgainButton')}
          </Button>
          <Button onClick={handleContactSupport} variant="outlined" fullWidth>
            {t('migration.step.error.contactSupportButton')}
          </Button>
        </Stack>
      </Box>
    </motion.div>
  );
};
